import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Button, Logo } from '../design-system/components';
import { useAuth } from '../lib/auth';

const navItems = [
  { to: '/app', label: 'Overview', end: true },
  { to: '/app/rooms', label: 'Chat rooms' },
  { to: '/app/family', label: 'My kids' },
  { to: '/app/grown-ups', label: 'Grown-ups' },
  { to: '/app/buddies', label: 'Buddy requests' },
  { to: '/app/settings', label: 'Safety settings' },
  { to: '/app/account', label: 'Account' },
  { to: '/app/support', label: 'Help & support' },
];

export function ParentDashboard() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside
        style={{
          width: 'var(--sidebar-w, 288px)',
          background: 'var(--white)',
          borderRight: 'var(--border-width) solid var(--border-default)',
          padding: 'var(--space-6) var(--space-4)',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-2)',
        }}
      >
        <div style={{ padding: '0 var(--space-2)', marginBottom: 'var(--space-4)' }}>
          <Logo height={32} />
        </div>
        <nav className="kz-stack" style={{ gap: 'var(--space-1)', flex: 1 }}>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              style={({ isActive }) => ({
                padding: '10px 14px',
                borderRadius: 'var(--radius-md)',
                font: 'var(--type-body-strong)',
                color: isActive ? 'var(--blue-700)' : 'var(--ink-600)',
                background: isActive ? 'var(--blue-50)' : 'transparent',
                textDecoration: 'none',
              })}
            >
              {item.label}
            </NavLink>
          ))}
          {user?.role === 'admin' && (
            <NavLink to="/admin" style={{ padding: '10px 14px', borderRadius: 'var(--radius-md)', font: 'var(--type-body-strong)', color: 'var(--grape-500)' }}>
              Admin console
            </NavLink>
          )}
        </nav>
        <div style={{ padding: 'var(--space-2)', borderTop: 'var(--border-width) solid var(--border-subtle)' }}>
          <p style={{ font: 'var(--type-small)' }}>{user?.displayName}</p>
          <Button
            variant="ghost"
            size="sm"
            onClick={async () => {
              await logout();
              nav('/');
            }}
          >
            Sign out
          </Button>
        </div>
      </aside>

      <main style={{ flex: 1, padding: 'var(--space-8)', maxWidth: 'var(--container-max, 1200px)' }}>
        <Outlet />
      </main>
    </div>
  );
}
